import type { Ref } from 'vue';
import type { ReadonlyDeep } from 'type-fest';
import type { ResultItem } from '@/utils/file';

import { ref } from 'vue';

import { downloadResultsAsCsv } from '@/utils/file';

export interface DownloadCsvComposable {
  isDownloadingCSV: Ref<boolean>;
  downloadCsv: (
    results: ResultItem[] | ReadonlyDeep<ResultItem[]>,
    stem: string,
  ) => void;
}

export default function useDownloadCsv(): DownloadCsvComposable {
  const isDownloadingCSV = ref(false);

  // TODO move to fetchers, add try/catch and async/await
  function downloadCsv(
    results: ResultItem[] | ReadonlyDeep<ResultItem[]>,
    stem: string,
  ): void {
    isDownloadingCSV.value = true;
    setTimeout(() => {
      downloadResultsAsCsv(results as ResultItem[], stem);
      isDownloadingCSV.value = false;
    }, 500);
  }

  return {
    isDownloadingCSV,
    downloadCsv,
  };
}
